import {
    GET_CONFIG_FORM15,
    GET_COMBO_MODO_CONTACTO_MODAL,
    GET_COMBO_RESPUESTA_CONTACTO_MODAL,
    GET_GRILLA_HISTORIAL,
    POST_ACTUALIZAR_CONTACTO,
    GET_DATOS_ULTIMOCONTACTO,
    SET_MODO_CONTACTO,
    SET_LOADING,
    SET_MODO,
    GET_CONFIG_FORM42
    
    
} from '../types';

export default function modalContactoTerceroReducer(state = {}, action) {
    switch (action.type) {
        case GET_CONFIG_FORM15:
            return { ...state, cfg_form15:action.payload }
        case SET_MODO:
            return { ...state, modoGlobal:action.payload }
        case GET_COMBO_MODO_CONTACTO_MODAL:
            return { ...state, comboModoContactoModal:action.payload }
        case GET_COMBO_RESPUESTA_CONTACTO_MODAL:
            return { ...state, comboRespuestaContactoModal:action.payload }
        case GET_GRILLA_HISTORIAL:
            return { ...state, grillaHistorial:action.payload }
        case POST_ACTUALIZAR_CONTACTO:
            return { ...state, respuestaContacto:action.payload }
        case  GET_DATOS_ULTIMOCONTACTO:
            return { ...state, datosUltimoContacto:action.payload }
       
        case  SET_MODO_CONTACTO:
            return { ...state, isModoContactoGlobal:action.payload }
        case  SET_LOADING:
            return { ...state, loadingGlobal:action.payload }
        case GET_CONFIG_FORM42:
            return { ...state, cfg_form42:action.payload }
       
        default:
            return state
    }
}